/**
 * Created by Yoyo Fang on 07/01/2019.
 * Description:
 * Ag-grid visible button
 * ------ maintenance history ------
 * Updated by Abner Sui on 07/25/2019
 * Change button disable status, 3 default screen can not change visible status
 */

import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ScreenService } from '../../tamalelibs/services/screen.service';
import { of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '../../redux';
import { SystemActionTypes } from '../../tamalelibs/redux/actions/system.actions';
import { businessConstants } from '../../constants/business.constants';

@Component({
    selector: 'tam-manage-screens-copy-button',
    template:
        `<div>
            <kendo-switch onLabel="Yes" offLabel="No" [(ngModel)]="visible" (click)="clicked($event)"
            [disabled]="loading||defaultScreen"></kendo-switch>
        </div>`,
    styleUrls: ['./manage-screens.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManageScreensVisibleButtonComponent implements ICellRendererAngularComp {

    visible: boolean;
    loading = false;
    defaultScreen: boolean;

    private _screen: any = null;

    constructor(
        private _store: Store<AppState>,
        private _changeDetectorRef: ChangeDetectorRef,
        private _screenService: ScreenService,
    ) { }

    agInit(params: any): void {
        this._screen = Object.assign({}, params.data);
        this.visible = params.data.visible;
        this.defaultScreen = [businessConstants.activityScreenId, businessConstants.allNotesScreenId, businessConstants.myNotesScreenId].includes(this._screen.id);
        // this._changeDetectorRef.detectChanges();
    }

    clicked(event: any): void {
        const setValue = this.visible;
        if (!this.loading && !this.defaultScreen) {
            this.loading = true;
            this._changeDetectorRef.detectChanges();
            this._screen.visible = setValue;
            const tempParam = {
                id: this._screen.id,
                visible: this._screen.visible,
            };
            this._screenService.update(tempParam).pipe(
                catchError(err => {
                    this._screen.visible = !setValue;
                    this.visible = !setValue;
                    return of(null);
                }),
                take(1),
            ).subscribe((response) => {
                if (response) {
                    this._screen = response;
                    this.visible = response.visible;
                    this._store.dispatch({
                        type: SystemActionTypes.SWITCH_VISIBLE,
                        payload: this._screen,
                    });
                }
                this.loading = false;
                this._changeDetectorRef.detectChanges();
            });
        }
    }

    refresh(): boolean {
        return true;
    }
}
